import { A } from '@solidjs/router';
import Text from './Text';
import LanguageChooser from "./LanguageChooser";
import NotificationBell from "./NotificationBell";
import HeaderBotSelector from "./HeaderBotSelector";
import { onMount, Show, type JSX } from "solid-js";
import { useUserContext } from "./UserContextProvider";
import { useLoadCurrentUser } from "../hooks/useLoadCurrentUser";
import TopNavLinks from "./TopNavLinks";
import styles from './Navbar.module.css';

interface NavbarProps {
    children: any;
    menuButton?: JSX.Element;
}

export default function Navbar(props: NavbarProps) {

    const { user } = useUserContext();
    const loadCurrentUser = useLoadCurrentUser();

    onMount(() => {
        void loadCurrentUser();
    });

    return (
        <>
            <div class={"navbar" + (user().loggedin ? " has-sidebar" : "")}>
                <div class="navbar-left">
                    {props.menuButton}
                    <A href="/" aria-label="Home" class={styles.navlogoLink}>
                        <img class={styles.navlogo} src={"/vektor_anim.svg"} />
                    </A>
                    <div class="navbar-nav-links">
                        <TopNavLinks />
                    </div>
                </div>
                <div class="navbar-right">
                    <Show when={user().loggedin}>
                        <HeaderBotSelector />
                        <NotificationBell />
                        <A class="navbar-mobile-icon" activeClass="active" inactiveClass="inactive" href="/me" aria-label={user().username}>
                            <i class="fa-solid fa-user" />
                        </A>
                    </Show>
                    <div class="navbar-auth-links">
                        <Show when={!user().loggedin}>
                            <A activeClass="active" inactiveClass="inactive" href="/login"><Text val="LOGIN"/></A>
                            <A activeClass="active" inactiveClass="inactive" href="/register" end><Text val="REGISTER"/></A>
                        </Show>
                        <Show when={user().loggedin}>
                            <A activeClass="active" inactiveClass="inactive" href="/me">{user().username}</A>
                        </Show>
                    </div>
                    <LanguageChooser></LanguageChooser>
                </div>
            </div>
                <div class="navbar-content">
                    {props.children}
                </div>
        </>
    )
}
